'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinimumStartTimestamp = undefined;

var _getters = require('./getters');

var getMinimumStartTimestamp = exports.getMinimumStartTimestamp = function getMinimumStartTimestamp(threadHistoryA, threadHistoryB) {
  var startA = (0, _getters.getStartTimestamp)(threadHistoryA);
  var startB = (0, _getters.getStartTimestamp)(threadHistoryB);

  if (!startA) {
    return startB;
  }

  if (!startB) {
    return startA;
  }

  return Math.min(startA, startB);
};